/**
 * Maps policy state codes to human-readable status labels
 */
export const policyStatusMap: { [key: string]: string } = {
  ACTIVEPOLICY: "Active",
  CANCELLEDPOLICY: "Cancelled",
  NONRENEWEDPOLICY: "Non-renewed",
};

/**
 * Gets the human-readable status for a policy state code
 * @param policyState - The policy state code (e.g., "ACTIVEPOLICY")
 * @returns The human-readable status, or "Unknown" if missing/unrecognized
 */
export const getPolicyStatus = (policyState?: string | null): string => {
  if (!policyState) return "Unknown";
  return policyStatusMap[policyState] ?? "Unknown";
};
